import React, { ReactNode, useMemo } from "react";
import { Button, Modal } from "react-bootstrap";
import { v4 } from "uuid";

export interface ConfirmDialogProps {
  readonly show: boolean;
  readonly title: ReactNode;
  readonly children?: ReactNode;
  readonly confirmLabel: ReactNode;
  /** Without it the dialog has a single action (e.g. *Close* on a blocking message). */
  readonly cancelLabel?: ReactNode;
  readonly onConfirm: () => void;
  readonly onCancel: () => void;
}

/** Generic dialog of the feature; texts are React nodes, never HTML strings. */
export function ConfirmDialog({
  show,
  title,
  children,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  const titleId = useMemo(() => `confirm-dialog-title-${v4()}`, []);

  return (
    <Modal show={show} centered aria-labelledby={titleId} onHide={onCancel}>
      <Modal.Header>
        <Modal.Title as="h2" id={titleId} className="h5">
          {title}
        </Modal.Title>
      </Modal.Header>
      {children && <Modal.Body>{children}</Modal.Body>}
      <Modal.Footer>
        {cancelLabel && (
          <Button type="button" variant="light" onClick={onCancel}>
            {cancelLabel}
          </Button>
        )}
        <Button type="button" variant="primary" autoFocus onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
